module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_chipotle.b932fc52.jpg";